var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row faq-container align-items-center mb-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12"},[_c('label',{staticClass:"form-label mb-1"},[_vm._v("Description générale")]),_vm._v(" "),_c('div',{ref:"editor"})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }